"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableData = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
function TableData(_a) {
    var { children, className = '' } = _a, tableDataProps = __rest(_a, ["children", "className"]);
    return ((0, jsx_runtime_1.jsx)("td", Object.assign({ className: (0, classnames_1.default)('px-4', 'text-body-small', 'text-silver-100', 'max-w-[208px]', className) }, tableDataProps, { children: children })));
}
exports.TableData = TableData;
//# sourceMappingURL=TableData.js.map